module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAABGdBTUEAALGPC/xhBQAAAFRQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFOB9uAAAABt0Uk5THdcxMtYe7bY+6RYCEZL7uO/lpuYcIizTzzAA7sVJGAAAAJVJREFUSMft18kKAjEQRdFy6nkyqW417///U3CpBMIL2KSpuz+LjCQSMpJycfci6j64uYLq1AQ5T2ifRC2mi8wYe2a8/YhZFgzcbA1YBGDnGjBcIv7Zvfd/4fW7my3VEfEjsbQdFimCt4SiOG2khg3vgrMORga2C/DI2EPJxza8ONSU1hpOtAJZpRLUeYZ6pyX/bvbBb8U5a4YDGQw1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_nav_layout.png
// module id = 547
// module chunks = 1